import { SET_CURRENCY_LIST, SET_CURRENT_USER, SET_DESKERA_INFO, SET_GUSTO_INFO, SET_USER_INFO } from "src/redux/types";
import { isEmpty } from "lodash";

const initialState = {
  isAuthenticated: false,
  user: {},
  deskeraInfo: {},
  gustoInfo: {}
};

function authReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.user),
        user: action.user,
      };
    case SET_DESKERA_INFO:
      return {
        ...state,
        deskeraInfo: action.info,
      };
    case SET_GUSTO_INFO:
      return {
        ...state,
        gustoInfo: action.info,
      };
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.info,
      };
    case SET_CURRENCY_LIST:
      return {
        ...state,
        currency: action.currency,
      };
    default:
      return state;
  }
}

export default authReducer;
